import { app } from '../../../core/App';
import { Sounds } from '../../../sounds';
import { Vehicle } from '../Vehicle';
import { EquipmentType } from '../VehicleEquipment';
import { VehicleEquipmentCapture } from '../VehicleEquipmentCapture';
import { VehicleHero } from '../VehicleHero';
import { VehicleVillain } from '../VehicleVillain';

export class VehicleCaptureGrapple extends VehicleEquipmentCapture {
  protected fireYPos: number;
  protected fireDistance: number;
  protected prefireTime: number;
  protected beforeHitTime: number;
  protected fireTime: number;

  constructor(scene: Phaser.Scene, vehicle: VehicleHero) {
    super(scene, EquipmentType.Grapple, vehicle);

    this.fireYPos = 0;
    this.fireDistance = 1000;
    this.prefireTime = 4000;
    this.beforeHitTime = 500;
    this.fireTime = 1000;
  }

  public beforeMoveIntoPosition(): void {}

  public afterMoveIntoPosition(): void {}

  public triggerCaptureFire(): void {
    app.audioHandler.playSound(this.scene, Sounds.Track.Grapple1, Sounds.Channel.SFX, { volume: 1.0 });
    this.vehicle.CharacterSpine.fireEquipment();
  }

  public beforeCaptureFire(): void {}

  public beforeCaptureHit(): void {}

  public onCaptureHit(): void {}

  public onPull(): void {
    app.audioHandler.playSound(this.scene, this.vehicle.sounds.cheer, Sounds.Channel.SFX, { volume: 1.0 });
    this.vehicle.CharacterSpine.heroPull();
  }
}
